package com.snakesworld.game.ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.ExitTransition
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.focusable
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectTransformGestures
import androidx.compose.foundation.indication
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.PressInteraction
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.ripple
import androidx.compose.ui.semantics.Role
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.withFrameNanos
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.drawscope.scale
import androidx.compose.ui.graphics.drawscope.translate
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEvent
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextMeasurer
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.delay
import com.snakesworld.game.domain.ArenaPlayerRef
import com.snakesworld.game.domain.NicknameDisplay
import com.snakesworld.game.domain.arenaOpponents
import com.snakesworld.game.engine.Direction
import com.snakesworld.game.supportsKeyboardBoostHint
import com.snakesworld.game.engine.GameConstants
import com.snakesworld.game.engine.SNAKE_SKIN_OPTIONS
import com.snakesworld.game.engine.SnakePlayer
import com.snakesworld.game.navigation.ConsumeMatchSystemBack
import com.snakesworld.game.network.ConnectionStatus
import com.snakesworld.game.network.DeathCause
import com.snakesworld.game.ui.theme.JoystickType
import com.snakesworld.game.ui.theme.LocalGameCanvasColors
import com.snakesworld.game.ui.theme.LocalJoystickType
import com.snakesworld.game.ui.theme.appFontFamily
import com.snakesworld.game.repository.LoggerRepositoryImpl
import com.snakesworld.game.viewmodel.GameViewModel
import kotlinx.coroutines.isActive
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import snakesworld.shared.generated.resources.Res
import snakesworld.shared.generated.resources.abort_confirm
import snakesworld.shared.generated.resources.abort_mission_desc
import snakesworld.shared.generated.resources.abort_mission_title
import snakesworld.shared.generated.resources.boost
import snakesworld.shared.generated.resources.cancel
import snakesworld.shared.generated.resources.connection_warning_desc
import snakesworld.shared.generated.resources.connection_warning_title
import snakesworld.shared.generated.resources.eliminated_boundary
import snakesworld.shared.generated.resources.eliminated_by
import snakesworld.shared.generated.resources.eliminated_self
import snakesworld.shared.generated.resources.final_kills
import snakesworld.shared.generated.resources.final_score
import snakesworld.shared.generated.resources.game_paused
import snakesworld.shared.generated.resources.hidden_player
import snakesworld.shared.generated.resources.ingame_tap_name
import snakesworld.shared.generated.resources.ic_arrow_down
import snakesworld.shared.generated.resources.ic_arrow_left
import snakesworld.shared.generated.resources.ic_arrow_right
import snakesworld.shared.generated.resources.ic_arrow_up
import snakesworld.shared.generated.resources.ic_minus
import snakesworld.shared.generated.resources.ic_pause
import snakesworld.shared.generated.resources.ic_play
import snakesworld.shared.generated.resources.ic_plus
import snakesworld.shared.generated.resources.kills
import snakesworld.shared.generated.resources.leaderboard
import snakesworld.shared.generated.resources.main_menu
import snakesworld.shared.generated.resources.mission_terminated
import snakesworld.shared.generated.resources.pause
import snakesworld.shared.generated.resources.players
import snakesworld.shared.generated.resources.play_again
import snakesworld.shared.generated.resources.restart
import snakesworld.shared.generated.resources.resume
import snakesworld.shared.generated.resources.score
import snakesworld.shared.generated.resources.time_survived
import kotlin.math.abs
import kotlin.math.round
import kotlin.math.roundToInt
import kotlin.math.sqrt
import kotlin.time.Duration.Companion.milliseconds

private val gameScreenLogger = LoggerRepositoryImpl(tag = "GameScreen")

@Composable
fun GameScreen(
    viewModel: GameViewModel,
    assignedId: String,
    nickname: String,
    skinId: String,
    isSinglePlayer: Boolean = false,
    blockedPlayerIds: Set<String> = emptySet(),
    onReportPlayer: (id: String, name: String) -> Unit = { _, _ -> },
    onBlockPlayer: (id: String) -> Unit = {},
    onExitMatch: () -> Unit,
) {
    ConsumeMatchSystemBack()
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    val canvasColors = LocalGameCanvasColors.current
    val textMeasurer = rememberTextMeasurer()
    val focusRequester = remember { FocusRequester() }
    var moderateTarget by remember { mutableStateOf<Pair<String, String>?>(null) }
    var showPlayers by remember { mutableStateOf(false) }
    val hiddenLabel = stringResource(Res.string.hidden_player)

    LaunchedEffect(assignedId, isSinglePlayer) {
        viewModel.startGame(assignedId, nickname, skinId, isSinglePlayer = isSinglePlayer)
    }

    // Ensure keyboard focus is reliably acquired and maintained across Web & Desktop
    LaunchedEffect(Unit) {
        repeat(10) {
            try {
                focusRequester.requestFocus()
                return@LaunchedEffect
            } catch (_: Throwable) {
                delay(50.milliseconds)
            }
        }
    }

    LaunchedEffect(uiState.isExitDialogVisible) {
        if (!uiState.isExitDialogVisible) {
            try {
                focusRequester.requestFocus()
            } catch (_: Throwable) {}
        }
    }

    // When unpausing, reclaim keyboard focus so movement responds immediately
    LaunchedEffect(uiState.isPaused) {
        if (!uiState.isPaused) {
            repeat(10) {
                try {
                    focusRequester.requestFocus()
                    return@LaunchedEffect
                } catch (_: Throwable) {
                    delay(50.milliseconds)
                }
            }
        }
    }

    // After Play Again dismisses game-over, reclaim keyboard focus (button click steals it)
    LaunchedEffect(uiState.gameState.isGameOver) {
        if (!uiState.gameState.isGameOver) {
            repeat(12) {
                try {
                    focusRequester.requestFocus()
                    return@LaunchedEffect
                } catch (_: Throwable) {
                    delay(50.milliseconds)
                }
            }
        }
    }

    // 60 FPS Simulation & Rendering Ticker
    LaunchedEffect(Unit) {
        var lastFrameNanos = 0L
        while (isActive) {
            withFrameNanos { frameTimeNanos ->
                if (lastFrameNanos > 0L) {
                    val deltaSeconds = ((frameTimeNanos - lastFrameNanos) / 1_000_000_000f).coerceIn(0.001f, 0.05f)
                    try {
                        viewModel.onFrame(deltaSeconds, frameTimeNanos)
                    } catch (e: Throwable) {
                        gameScreenLogger.e("onFrame error: ${e::class.simpleName}: ${e.message}")
                    }
                }
                lastFrameNanos = frameTimeNanos
            }
        }
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(canvasColors.backgroundColor)
            .focusRequester(focusRequester)
            .focusable()
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        try {
                            focusRequester.requestFocus()
                        } catch (_: Throwable) {}
                    }
                )
            }
            .onPreviewKeyEvent { keyEvent ->
                handleArcadeKeyEvent(keyEvent, viewModel, isSinglePlayer, uiState.isPaused, uiState.isExitDialogVisible)
            }
            .onKeyEvent { keyEvent ->
                handleArcadeKeyEvent(keyEvent, viewModel, isSinglePlayer, uiState.isPaused, uiState.isExitDialogVisible)
            }
    ) {
        val localSnake = uiState.gameState.localPlayer
        val zoom = uiState.cameraZoom

        // 60 FPS Compose Canvas World Rendering with Pinch-to-Zoom
        Canvas(
            modifier = Modifier
                .fillMaxSize()
                .pointerInput(Unit) {
                    detectTapGestures(
                        onPress = {
                            try {
                                focusRequester.requestFocus()
                            } catch (_: Throwable) {}
                        }
                    )
                }
                .pointerInput(Unit) {
                    detectTransformGestures { _, _, zoomChange, _ ->
                        if (zoomChange != 1.0f) {
                            viewModel.onZoomChange(zoomChange)
                        }
                    }
                }
                // Desktop / web mouse wheel zoom
                .pointerInput(Unit) {
                    awaitPointerEventScope {
                        while (true) {
                            val event = awaitPointerEvent()
                            if (event.type != PointerEventType.Scroll) continue
                            val change = event.changes.firstOrNull() ?: continue
                            val scrollY = change.scrollDelta.y
                            if (scrollY == 0f) continue
                            // Wheel up (negative Y) zooms in — same convention as maps
                            val factor = kotlin.math.exp(-scrollY * 0.004)
                                .toFloat()
                                .coerceIn(0.85f, 1.15f)
                            if (factor != 1f) {
                                viewModel.onZoomChange(factor)
                            }
                            change.consume()
                        }
                    }
                }
                // Touch/stylus swipe on the playfield (mouse ignored so wheel zoom / drag stay intact)
                .pointerInput(uiState.gameState.isGameOver, uiState.isPaused) {
                    if (uiState.gameState.isGameOver || uiState.isPaused) return@pointerInput
                    detectArenaSwipe { dir -> viewModel.onDirectionInput(dir) }
                }
        ) {
            val canvasW = size.width
            val canvasH = size.height
            val centerX = canvasW / 2f
            val centerY = canvasH / 2f

            val camX = if (localSnake != null) uiState.cameraX else 0f
            val camY = if (localSnake != null) uiState.cameraY else 0f

            // Apply camera zoom and centered tracking
            scale(scaleX = zoom, scaleY = zoom, pivot = Offset(centerX, centerY)) {
                translate(left = centerX - camX, top = centerY - camY) {
                    // 1. Theme-aware Retro Arena Grid Lines (bounded to square arena)
                    val arenaHalf = GameConstants.ARENA_HALF_SIZE
                    val gridSize = 100f
                    val visibleLeft = camX - (canvasW / 2f) / zoom
                    val visibleRight = camX + (canvasW / 2f) / zoom
                    val visibleTop = camY - (canvasH / 2f) / zoom
                    val visibleBottom = camY + (canvasH / 2f) / zoom

                    val leftGrid = maxOf(-arenaHalf, (visibleLeft / gridSize).toInt() * gridSize - gridSize)
                    val rightGrid = minOf(arenaHalf, (visibleRight / gridSize).toInt() * gridSize + gridSize)
                    val topGrid = maxOf(-arenaHalf, (visibleTop / gridSize).toInt() * gridSize - gridSize)
                    val bottomGrid = minOf(arenaHalf, (visibleBottom / gridSize).toInt() * gridSize + gridSize)

                    val boundTop = maxOf(-arenaHalf, visibleTop)
                    val boundBottom = minOf(arenaHalf, visibleBottom)
                    val boundLeft = maxOf(-arenaHalf, visibleLeft)
                    val boundRight = minOf(arenaHalf, visibleRight)

                    if (boundLeft < boundRight && boundTop < boundBottom) {
                        var gx = leftGrid
                        while (gx <= rightGrid) {
                            if (gx in -arenaHalf..arenaHalf) {
                                drawLine(
                                    color = canvasColors.gridColor,
                                    start = Offset(gx, boundTop),
                                    end = Offset(gx, boundBottom),
                                    strokeWidth = 1f
                                )
                            }
                            gx += gridSize
                        }
                        var gy = topGrid
                        while (gy <= bottomGrid) {
                            if (gy in -arenaHalf..arenaHalf) {
                                drawLine(
                                    color = canvasColors.gridColor,
                                    start = Offset(boundLeft, gy),
                                    end = Offset(boundRight, gy),
                                    strokeWidth = 1f
                                )
                            }
                            gy += gridSize
                        }
                    }

                    // 2. Square Electric Arena Boundary & Retro Corner Brackets
                    val arenaSize = arenaHalf * 2f

                    // Outer glowing electric boundary halo
                    drawRect(
                        color = canvasColors.boundaryColor.copy(alpha = 0.2f),
                        topLeft = Offset(-arenaHalf - 12f, -arenaHalf - 12f),
                        size = Size(arenaSize + 24f, arenaSize + 24f),
                        style = Stroke(width = 24f)
                    )

                    // Sharp neon boundary line
                    drawRect(
                        color = canvasColors.boundaryColor,
                        topLeft = Offset(-arenaHalf, -arenaHalf),
                        size = Size(arenaSize, arenaSize),
                        style = Stroke(width = 6f)
                    )

                    // Retro arcade corner brackets
                    val bracketLen = 80f
                    // Top-Left Corner
                    drawLine(canvasColors.boundaryColor, Offset(-arenaHalf, -arenaHalf), Offset(-arenaHalf + bracketLen, -arenaHalf), strokeWidth = 10f)
                    drawLine(canvasColors.boundaryColor, Offset(-arenaHalf, -arenaHalf), Offset(-arenaHalf, -arenaHalf + bracketLen), strokeWidth = 10f)
                    // Top-Right Corner
                    drawLine(canvasColors.boundaryColor, Offset(arenaHalf, -arenaHalf), Offset(arenaHalf - bracketLen, -arenaHalf), strokeWidth = 10f)
                    drawLine(canvasColors.boundaryColor, Offset(arenaHalf, -arenaHalf), Offset(arenaHalf, -arenaHalf + bracketLen), strokeWidth = 10f)
                    // Bottom-Left Corner
                    drawLine(canvasColors.boundaryColor, Offset(-arenaHalf, arenaHalf), Offset(-arenaHalf + bracketLen, arenaHalf), strokeWidth = 10f)
                    drawLine(canvasColors.boundaryColor, Offset(-arenaHalf, arenaHalf), Offset(-arenaHalf, arenaHalf - bracketLen), strokeWidth = 10f)
                    // Bottom-Right Corner
                    drawLine(canvasColors.boundaryColor, Offset(arenaHalf, arenaHalf), Offset(arenaHalf - bracketLen, arenaHalf), strokeWidth = 10f)
                    drawLine(canvasColors.boundaryColor, Offset(arenaHalf, arenaHalf), Offset(arenaHalf, arenaHalf - bracketLen), strokeWidth = 10f)

                    // 3. Render Food Pellets (same-size grid squares as snake parts)
                    val cellHalf = GameConstants.CELL_HALF_SIZE
                    val glowHalf = cellHalf + 3f
                    for (pellet in uiState.gameState.pellets.values) {
                        val pPos = Offset(pellet.position.x, pellet.position.y)
                        val pColor = Color(pellet.color)

                        drawRect(
                            color = pColor.copy(alpha = 0.3f),
                            topLeft = Offset(pPos.x - glowHalf, pPos.y - glowHalf),
                            size = Size(glowHalf * 2f, glowHalf * 2f),
                        )
                        drawRect(
                            color = pColor,
                            topLeft = Offset(pPos.x - cellHalf, pPos.y - cellHalf),
                            size = Size(cellHalf * 2f, cellHalf * 2f),
                        )
                        if (pellet.isCorpse) {
                            drawRect(
                                color = Color.White,
                                topLeft = Offset(pPos.x - cellHalf, pPos.y - cellHalf),
                                size = Size(cellHalf * 2f, cellHalf * 2f),
                                style = Stroke(2f),
                            )
                        }
                    }

                    // 4. Render Remote Opponent Snakes (with hovering nicknames)
                    for (remote in uiState.gameState.remoteSnakes.values) {
                        if (!remote.isAlive) continue
                        val shownName = NicknameDisplay.visibleName(
                            raw = remote.name,
                            playerId = remote.id,
                            blockedIds = blockedPlayerIds,
                            hiddenLabel = hiddenLabel,
                        )
                        drawSnake(
                            scope = this,
                            snake = remote.copy(name = shownName),
                            textMeasurer = textMeasurer,
                            showNameLabel = true,
                        )
                    }

                    // 5. Render Local Player Snake (no floating nick — HUD already identifies you)
                    if (localSnake != null && localSnake.isAlive) {
                        drawSnake(scope = this, snake = localSnake)
                    }
                }
            }
        }

        // HUD Layer with Safe Area Padding
        Box(
            modifier = Modifier
                .fillMaxSize()
                .windowInsetsPadding(WindowInsets.safeDrawing)
                .padding(12.dp)
        ) {
            // Top-left back (opens exit confirm) and (in single player) pause button below it
            Column(
                modifier = Modifier.align(Alignment.TopStart),
                verticalArrangement = Arrangement.spacedBy(8.dp),
                horizontalAlignment = Alignment.Start,
            ) {
                ScreenBackButton(
                    onBack = { viewModel.showExitDialog(true) },
                    canvasColors = canvasColors,
                )
                if (!isSinglePlayer) {
                    PlayersButton(
                        onClick = { showPlayers = true },
                        canvasColors = canvasColors,
                    )
                }
                if (isSinglePlayer && !uiState.gameState.isGameOver) {
                    ArcadePauseButton(
                        isPaused = uiState.isPaused,
                        onTogglePause = { viewModel.togglePause() },
                        canvasColors = canvasColors,
                    )
                }
            }

            // Arcade Stats Counter Banner (top center)
            Row(
                modifier = Modifier
                    .align(Alignment.TopCenter)
                    .background(canvasColors.hudBgColor, RoundedCornerShape(8.dp))
                    .border(1.dp, canvasColors.gridColor, RoundedCornerShape(8.dp))
                    .padding(horizontal = 12.dp, vertical = 6.dp),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                HudCounter(stringResource(Res.string.score), "${localSnake?.score ?: 0}", canvasColors.accentColor)
                HudCounter(stringResource(Res.string.kills), "${localSnake?.kills ?: 0}", canvasColors.hudTextColor)
            }

            // Top-Right: Live In-Game Leaderboard
            Column(
                modifier = Modifier
                    .align(Alignment.TopEnd),
                horizontalAlignment = Alignment.End,
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                // Live In-Game Leaderboard (Top 5)
                val topEntries = uiState.gameState.leaderboard.take(5)
                if (topEntries.isNotEmpty()) {
                    Column(
                        modifier = Modifier
                            .width(168.dp)
                            .background(canvasColors.hudBgColor.copy(alpha = 0.85f), RoundedCornerShape(8.dp))
                            .border(1.dp, canvasColors.gridColor, RoundedCornerShape(8.dp))
                            .padding(horizontal = 8.dp, vertical = 6.dp),
                        verticalArrangement = Arrangement.spacedBy(2.dp)
                    ) {
                        Text(
                            text = stringResource(Res.string.leaderboard),
                            color = canvasColors.accentColor,
                            fontSize = 10.sp,
                            fontWeight = FontWeight.Black,
                            fontFamily = appFontFamily(),
                            letterSpacing = 1.sp,
                            maxLines = 1,
                            softWrap = false,
                            overflow = TextOverflow.Ellipsis,
                        )
                        if (!isSinglePlayer) {
                            Text(
                                text = stringResource(Res.string.ingame_tap_name),
                                color = canvasColors.hudTextColor.copy(alpha = 0.65f),
                                fontSize = 8.sp,
                                fontFamily = appFontFamily(),
                                fontWeight = FontWeight.Bold,
                                maxLines = 1,
                                softWrap = false,
                                overflow = TextOverflow.Ellipsis,
                            )
                        }
                        for ((idx, entry) in topEntries.withIndex()) {
                            val isMe = entry.id == localSnake?.id
                            val shownName = NicknameDisplay.visibleName(
                                raw = entry.name,
                                playerId = entry.id,
                                blockedIds = blockedPlayerIds,
                                hiddenLabel = hiddenLabel,
                            )
                            val canModerate = !isSinglePlayer && !isMe && entry.id !in blockedPlayerIds
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(vertical = 1.dp)
                                    .clickable(enabled = canModerate) {
                                        moderateTarget = entry.id to entry.name
                                    },
                                horizontalArrangement = Arrangement.spacedBy(4.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    text = "${idx + 1}.",
                                    color = if (isMe) canvasColors.accentColor else canvasColors.hudTextColor.copy(alpha = 0.6f),
                                    fontSize = 9.sp,
                                    fontFamily = appFontFamily(),
                                    fontWeight = if (isMe) FontWeight.Bold else FontWeight.Normal,
                                    maxLines = 1,
                                    softWrap = false,
                                )
                                EllipsizedNickname(
                                    text = shownName,
                                    color = if (isMe) {
                                        canvasColors.accentColor
                                    } else if (entry.id in blockedPlayerIds) {
                                        canvasColors.hudTextColor.copy(alpha = 0.55f)
                                    } else {
                                        canvasColors.hudTextColor
                                    },
                                    fontSize = 9.sp,
                                    fontWeight = if (isMe) FontWeight.Bold else FontWeight.Normal,
                                    modifier = Modifier.weight(1f),
                                )
                                Text(
                                    text = "${entry.score}",
                                    color = if (isMe) canvasColors.accentColor else canvasColors.boundaryColor,
                                    fontSize = 9.sp,
                                    fontFamily = appFontFamily(),
                                    fontWeight = FontWeight.Black,
                                    maxLines = 1,
                                    softWrap = false,
                                )
                            }
                        }
                    }
                }

            }

            // Unstable / Offline Connection Warning Banner
            AnimatedVisibility(
                visible = uiState.connectionStatus != ConnectionStatus.Connected,
                enter = fadeIn(),
                exit = fadeOut(),
                modifier = Modifier.align(Alignment.TopCenter).padding(top = 56.dp)
            ) {
                Box(
                    modifier = Modifier
                        .background(Color(0xE6FF1744), RoundedCornerShape(8.dp))
                        .border(2.dp, Color.White, RoundedCornerShape(8.dp))
                        .padding(horizontal = 16.dp, vertical = 8.dp)
                ) {
                    Column(horizontalAlignment = Alignment.CenterHorizontally) {
                        Text(
                            text = "⚠ ${stringResource(Res.string.connection_warning_title)}",
                            color = Color.White,
                            fontSize = 13.sp,
                            fontWeight = FontWeight.Black,
                            fontFamily = appFontFamily()
                        )
                        Text(
                            text = stringResource(Res.string.connection_warning_desc),
                            color = Color.White.copy(alpha = 0.9f),
                            fontSize = 9.sp,
                            fontFamily = appFontFamily()
                        )
                    }
                }
            }

            // Bottom Arcade Controls: Zoom + Direction on Left, Boost on Right
            Row(
                modifier = Modifier.fillMaxWidth().align(Alignment.BottomCenter),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Bottom
            ) {
                val joystickTypeState = LocalJoystickType.current

                // Zoom centered above D-Pad / Joystick
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(8.dp),
                ) {
                    ArcadeZoomControls(
                        zoomMultiplier = uiState.userZoomMultiplier,
                        onZoomIn = { viewModel.onZoomIn() },
                        onZoomOut = { viewModel.onZoomOut() },
                        onResetZoom = { viewModel.onResetZoom() },
                        canvasColors = canvasColors
                    )
                    if (joystickTypeState.value == JoystickType.Joystick) {
                        ArcadeVirtualJoystick(
                            onDirection = { dir -> viewModel.onDirectionInput(dir) },
                            canvasColors = canvasColors
                        )
                    } else {
                        ArcadeDPad(
                            onDirection = { dir -> viewModel.onDirectionInput(dir) },
                            canvasColors = canvasColors
                        )
                    }
                }

                // Big Arcade Boost Action Button
                ArcadeBoostButton(
                    isBoosting = localSnake?.isBoosting == true,
                    onBoostChange = { boosting -> viewModel.onBoostInput(boosting) },
                    canvasColors = canvasColors
                )
            }
        }

        // Single-Player Pause Overlay with pop-up animation
        AnimatedVisibility(
            visible = isSinglePlayer && uiState.isPaused && !uiState.gameState.isGameOver,
            enter = fadeIn(animationSpec = tween(180)) + scaleIn(
                initialScale = 0.88f,
                animationSpec = spring(dampingRatio = 0.8f, stiffness = Spring.StiffnessMediumLow)
            ),
            exit = ExitTransition.None
        ) {
            PauseOverlay(
                score = localSnake?.score ?: 0,
                kills = localSnake?.kills ?: 0,
                canvasColors = canvasColors,
                onResume = { viewModel.resumeGame() },
                onRestart = { viewModel.onPlayAgain() },
                onMainMenu = { viewModel.showExitDialog(true) },
            )
        }

        // Game Over Overlay with pop-up animation
        AnimatedVisibility(
            visible = uiState.gameState.isGameOver,
            enter = fadeIn(animationSpec = tween(220)) + scaleIn(
                initialScale = 0.88f,
                animationSpec = spring(dampingRatio = 0.8f, stiffness = Spring.StiffnessMediumLow)
            ),
            exit = ExitTransition.None
        ) {
            val stats = uiState.gameState.gameOverStats
            GameOverOverlay(
                stats = stats,
                canvasColors = canvasColors,
                blockedPlayerIds = blockedPlayerIds,
                hiddenLabel = hiddenLabel,
                onPlayAgain = { viewModel.onPlayAgain() },
                onMainMenu = { viewModel.onConfirmExit(onExitMatch) }
            )
        }

        // In-Game Exit Confirmation Dialog with smooth enter/exit animations
        ArcadeDialog(
            visible = uiState.isExitDialogVisible,
            onDismissRequest = { viewModel.showExitDialog(false) },
            title = {
                Text(
                    text = stringResource(Res.string.abort_mission_title),
                    fontFamily = appFontFamily(),
                    fontWeight = FontWeight.Black,
                    color = canvasColors.dangerColor,
                    fontSize = 18.sp,
                    letterSpacing = 1.sp
                )
            },
            text = {
                Text(
                    text = stringResource(Res.string.abort_mission_desc),
                    fontFamily = appFontFamily(),
                    color = canvasColors.hudTextColor,
                    fontSize = 13.sp
                )
            },
            confirmButton = {
                Button(
                    onClick = { viewModel.onConfirmExit(onExitMatch) },
                    colors = ButtonDefaults.buttonColors(
                        containerColor = canvasColors.dangerColor,
                        contentColor = Color.White
                    ),
                    shape = RoundedCornerShape(6.dp)
                ) {
                    Text(
                        text = stringResource(Res.string.abort_confirm),
                        fontFamily = appFontFamily(),
                        fontWeight = FontWeight.Bold,
                        color = Color.White
                    )
                }
            },
            dismissButton = {
                TextButton(
                    onClick = { viewModel.showExitDialog(false) },
                    colors = ButtonDefaults.textButtonColors(contentColor = canvasColors.hudTextColor)
                ) {
                    Text(
                        text = stringResource(Res.string.cancel),
                        fontFamily = appFontFamily(),
                        color = canvasColors.hudTextColor
                    )
                }
            },
            borderColor = canvasColors.dangerColor,
            canvasColors = canvasColors
        )

        if (!isSinglePlayer && showPlayers) {
            val localId = localSnake?.id ?: assignedId
            val opponents = arenaOpponents(
                localPlayerId = localId,
                remotePlayers = uiState.gameState.remoteSnakes.values.map { snake ->
                    ArenaPlayerRef(snake.id, snake.name)
                },
                leaderboard = uiState.gameState.leaderboard.map { entry ->
                    ArenaPlayerRef(entry.id, entry.name)
                },
            )
            MatchPlayersOverlay(
                players = opponents,
                blockedPlayerIds = blockedPlayerIds,
                hiddenLabel = hiddenLabel,
                canvasColors = canvasColors,
                onPlayerClick = { id, rawName ->
                    moderateTarget = id to rawName
                },
                onDismiss = { showPlayers = false },
            )
        }

        if (!isSinglePlayer) {
            val targetId = moderateTarget?.first
            val rawName = moderateTarget?.second
            PlayerModerationDialog(
                playerId = targetId,
                rawName = rawName,
                displayName = if (targetId == null || rawName == null) {
                    ""
                } else {
                    NicknameDisplay.visibleName(rawName, targetId, blockedPlayerIds, hiddenLabel)
                },
                onReport = onReportPlayer,
                onBlock = onBlockPlayer,
                onDismiss = { moderateTarget = null },
            )
        }
    }
}

private fun drawSnake(
    scope: androidx.compose.ui.graphics.drawscope.DrawScope,
    snake: SnakePlayer,
    textMeasurer: TextMeasurer? = null,
    showNameLabel: Boolean = false,
) {
    val skin = SNAKE_SKIN_OPTIONS.find { it.id == snake.skinId } ?: SNAKE_SKIN_OPTIONS.first()
    val primary = Color(skin.primaryColor)

    // Draw body segments from tail to neck (uniform color retro squares)
    val segs = snake.segments
    val cellHalf = GameConstants.CELL_HALF_SIZE
    val glowHalf = cellHalf + 3f
    for (i in segs.indices.reversed()) {
        val seg = segs[i]
        val pos = Offset(seg.position.x, seg.position.y)

        // Outer neon glow
        scope.drawRect(
            color = primary.copy(alpha = 0.25f),
            topLeft = Offset(pos.x - glowHalf, pos.y - glowHalf),
            size = Size(glowHalf * 2f, glowHalf * 2f)
        )
        // Solid square segment (same size as head and pellets)
        scope.drawRect(
            color = primary,
            topLeft = Offset(pos.x - cellHalf, pos.y - cellHalf),
            size = Size(cellHalf * 2f, cellHalf * 2f)
        )
        // Dark outline for segment separation
        scope.drawRect(
            color = Color.Black.copy(alpha = 0.35f),
            topLeft = Offset(pos.x - cellHalf, pos.y - cellHalf),
            size = Size(cellHalf * 2f, cellHalf * 2f),
            style = Stroke(2f)
        )
    }

    // Draw Snake Head (same grid square as body)
    val headPos = Offset(snake.headPosition.x, snake.headPosition.y)
    scope.drawRect(
        color = primary.copy(alpha = 0.4f),
        topLeft = Offset(headPos.x - glowHalf, headPos.y - glowHalf),
        size = Size(glowHalf * 2f, glowHalf * 2f)
    )
    scope.drawRect(
        color = primary,
        topLeft = Offset(headPos.x - cellHalf, headPos.y - cellHalf),
        size = Size(cellHalf * 2f, cellHalf * 2f)
    )
    scope.drawRect(
        color = Color.White,
        topLeft = Offset(headPos.x - cellHalf, headPos.y - cellHalf),
        size = Size(cellHalf * 2f, cellHalf * 2f),
        style = Stroke(2f)
    )

    // Animated retro square eyes directed toward heading
    val dirVector = snake.direction.toVector()
    val eyeOffset = 6f
    val leftEyePos = Offset(
        headPos.x + dirVector.x * 7f - dirVector.y * eyeOffset,
        headPos.y + dirVector.y * 7f + dirVector.x * eyeOffset
    )
    val rightEyePos = Offset(
        headPos.x + dirVector.x * 7f + dirVector.y * eyeOffset,
        headPos.y + dirVector.y * 7f - dirVector.x * eyeOffset
    )

    // Eye whites (retro pixel squares)
    val eyeHalf = 3.5f
    scope.drawRect(
        color = Color.White,
        topLeft = Offset(leftEyePos.x - eyeHalf, leftEyePos.y - eyeHalf),
        size = Size(eyeHalf * 2f, eyeHalf * 2f)
    )
    scope.drawRect(
        color = Color.White,
        topLeft = Offset(rightEyePos.x - eyeHalf, rightEyePos.y - eyeHalf),
        size = Size(eyeHalf * 2f, eyeHalf * 2f)
    )
    // Pupils (retro pixel squares)
    val pupilShift = Offset(dirVector.x * 2f, dirVector.y * 2f)
    val pupilHalf = 1.8f
    scope.drawRect(
        color = Color.Black,
        topLeft = Offset(leftEyePos.x + pupilShift.x - pupilHalf, leftEyePos.y + pupilShift.y - pupilHalf),
        size = Size(pupilHalf * 2f, pupilHalf * 2f)
    )
    scope.drawRect(
        color = Color.Black,
        topLeft = Offset(rightEyePos.x + pupilShift.x - pupilHalf, rightEyePos.y + pupilShift.y - pupilHalf),
        size = Size(pupilHalf * 2f, pupilHalf * 2f)
    )

    if (showNameLabel && textMeasurer != null) {
        drawEnemyNameLabel(
            scope = scope,
            textMeasurer = textMeasurer,
            name = snake.name,
            headX = headPos.x,
            headY = headPos.y,
            cellHalf = cellHalf,
        )
    }
}

/** World-space cap for a name floating above a snake. Longer names ellipsize. */
private const val NAME_LABEL_MAX_WIDTH = 108f

/**
 * Floating nickname above an enemy snake head (world-space; scales with camera zoom).
 */
private fun drawEnemyNameLabel(
    scope: androidx.compose.ui.graphics.drawscope.DrawScope,
    textMeasurer: TextMeasurer,
    name: String,
    headX: Float,
    headY: Float,
    cellHalf: Float,
) {
    val fontSize = with(scope) { 14f.toSp() }
    val style = TextStyle(
        color = Color.White,
        fontSize = fontSize,
        fontWeight = FontWeight.Bold,
        fontFamily = FontFamily.Monospace,
        textAlign = TextAlign.Center,
        shadow = Shadow(
            color = Color.Black.copy(alpha = 0.9f),
            offset = Offset(1f, 1f),
            blurRadius = 3f,
        ),
    )
    val label = NicknameDisplay.ellipsizeToWidth(
        text = name.trim().ifBlank { "?" },
        maxWidth = NAME_LABEL_MAX_WIDTH,
        measure = { candidate ->
            textMeasurer.measure(
                text = candidate,
                style = style,
                softWrap = false,
                maxLines = 1,
            ).size.width.toFloat()
        },
    )
    with(scope) {
        val layout = textMeasurer.measure(
            text = label,
            style = style,
            softWrap = false,
            maxLines = 1,
        )
        val gap = 8f
        drawText(
            textLayoutResult = layout,
            topLeft = Offset(
                headX - layout.size.width / 2f,
                headY - cellHalf - layout.size.height - gap,
            ),
        )
    }
}

@Composable
private fun HudCounter(label: String, value: String, color: Color) {
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Text(text = label, color = color.copy(alpha = 0.7f), fontSize = 9.sp, fontFamily = appFontFamily(), fontWeight = FontWeight.Bold)
        Text(text = value, color = color, fontSize = 16.sp, fontFamily = appFontFamily(), fontWeight = FontWeight.Black)
    }
}

@Composable
private fun ArcadeDPad(
    onDirection: (Direction) -> Unit,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
) {
    Box(
        modifier = Modifier.size(136.dp),
        contentAlignment = Alignment.Center
    ) {
        // Center cross background
        Box(
            modifier = Modifier
                .size(46.dp)
                .background(canvasColors.hudBgColor, RoundedCornerShape(4.dp))
                .border(1.dp, canvasColors.gridColor, RoundedCornerShape(4.dp))
        )

        // UP Button
        DPadBtn(
            icon = Res.drawable.ic_arrow_up,
            contentDescription = "UP",
            modifier = Modifier.align(Alignment.TopCenter),
            onClick = { onDirection(Direction.UP) },
            canvasColors = canvasColors
        )
        // DOWN Button
        DPadBtn(
            icon = Res.drawable.ic_arrow_down,
            contentDescription = "DOWN",
            modifier = Modifier.align(Alignment.BottomCenter),
            onClick = { onDirection(Direction.DOWN) },
            canvasColors = canvasColors
        )
        // LEFT Button
        DPadBtn(
            icon = Res.drawable.ic_arrow_left,
            contentDescription = "LEFT",
            modifier = Modifier.align(Alignment.CenterStart),
            onClick = { onDirection(Direction.LEFT) },
            canvasColors = canvasColors
        )
        // RIGHT Button
        DPadBtn(
            icon = Res.drawable.ic_arrow_right,
            contentDescription = "RIGHT",
            modifier = Modifier.align(Alignment.CenterEnd),
            onClick = { onDirection(Direction.RIGHT) },
            canvasColors = canvasColors
        )
    }
}

@Composable
private fun DPadBtn(
    icon: DrawableResource,
    contentDescription: String,
    modifier: Modifier,
    onClick: () -> Unit,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
) {
    val shape = RoundedCornerShape(6.dp)
    val interactionSource = remember { MutableInteractionSource() }
    Box(
        modifier = modifier
            .size(44.dp)
            .focusProperties { canFocus = false }
            .clip(shape)
            .background(canvasColors.hudBgColor, shape)
            .border(1.5.dp, canvasColors.hudTextColor, shape)
            .clickable(
                interactionSource = interactionSource,
                indication = ripple(bounded = true, color = canvasColors.hudTextColor),
                role = Role.Button,
                onClick = onClick,
            ),
        contentAlignment = Alignment.Center
    ) {
        Icon(
            painter = painterResource(icon),
            contentDescription = contentDescription,
            tint = canvasColors.hudTextColor,
            modifier = Modifier.size(20.dp)
        )
    }
}

@Composable
private fun ArcadeVirtualJoystick(
    onDirection: (Direction) -> Unit,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
) {
    var knobOffset by remember { mutableStateOf(Offset.Zero) }
    var isDragging by remember { mutableStateOf(false) }
    var lastDirection by remember { mutableStateOf<Direction?>(null) }
    val density = LocalDensity.current
    val maxRadiusPx = with(density) { 40.dp.toPx() }
    val deadzonePx = with(density) { 10.dp.toPx() }

    Box(
        modifier = Modifier
            .size(136.dp)
            .focusProperties { canFocus = false }
            .pointerInput(Unit) {
                awaitEachGesture {
                    val down = awaitFirstDown(requireUnconsumed = false)
                    isDragging = true
                    val center = Offset(size.width / 2f, size.height / 2f)

                    fun updateFromPosition(touchPos: Offset) {
                        val rawDelta = touchPos - center
                        val dist = sqrt(rawDelta.x * rawDelta.x + rawDelta.y * rawDelta.y)
                        knobOffset = if (dist > maxRadiusPx && dist > 0f) {
                            rawDelta * (maxRadiusPx / dist)
                        } else {
                            rawDelta
                        }

                        if (dist >= deadzonePx) {
                            val dir = if (abs(rawDelta.x) > abs(rawDelta.y)) {
                                if (rawDelta.x > 0f) Direction.RIGHT else Direction.LEFT
                            } else {
                                if (rawDelta.y > 0f) Direction.DOWN else Direction.UP
                            }
                            if (dir != lastDirection) {
                                lastDirection = dir
                                onDirection(dir)
                            }
                        }
                    }

                    updateFromPosition(down.position)

                    val pointerId = down.id
                    while (true) {
                        val event = awaitPointerEvent()
                        val change = event.changes.firstOrNull { it.id == pointerId } ?: break
                        if (!change.pressed) {
                            break
                        }
                        updateFromPosition(change.position)
                        change.consume()
                    }

                    isDragging = false
                    knobOffset = Offset.Zero
                    lastDirection = null
                }
            },
        contentAlignment = Alignment.Center
    ) {
        // Joystick Base Canvas
        Canvas(modifier = Modifier.fillMaxSize()) {
            val w = size.width
            val h = size.height
            val center = Offset(w / 2f, h / 2f)
            val outerRadius = w / 2f - 4f

            // Base circle background
            drawCircle(
                color = canvasColors.hudBgColor,
                radius = outerRadius,
                center = center
            )

            // Outer boundary ring
            drawCircle(
                color = if (isDragging) canvasColors.accentColor.copy(alpha = 0.6f) else canvasColors.hudTextColor.copy(alpha = 0.4f),
                radius = outerRadius,
                center = center,
                style = Stroke(width = 2f)
            )

            // Inner guide circle
            drawCircle(
                color = canvasColors.gridColor.copy(alpha = 0.6f),
                radius = outerRadius * 0.5f,
                center = center,
                style = Stroke(width = 1f)
            )

            // 4 Directional Accent Ticks on the rim
            val tickLen = 8f
            val tickColor = canvasColors.hudTextColor.copy(alpha = 0.7f)
            // UP
            drawLine(tickColor, Offset(center.x, center.y - outerRadius + 2f), Offset(center.x, center.y - outerRadius + 2f + tickLen), strokeWidth = 3f)
            // DOWN
            drawLine(tickColor, Offset(center.x, center.y + outerRadius - 2f), Offset(center.x, center.y + outerRadius - 2f - tickLen), strokeWidth = 3f)
            // LEFT
            drawLine(tickColor, Offset(center.x - outerRadius + 2f, center.y), Offset(center.x - outerRadius + 2f + tickLen, center.y), strokeWidth = 3f)
            // RIGHT
            drawLine(tickColor, Offset(center.x + outerRadius - 2f, center.y), Offset(center.x + outerRadius - 2f - tickLen, center.y), strokeWidth = 3f)
        }

        // Movable Joystick Thumb Knob
        Box(
            modifier = Modifier
                .offset {
                    IntOffset(knobOffset.x.roundToInt(), knobOffset.y.roundToInt())
                }
                .size(48.dp)
                .background(canvasColors.hudBgColor, CircleShape)
                .border(
                    width = 2.dp,
                    color = if (isDragging) canvasColors.accentColor else canvasColors.hudTextColor,
                    shape = CircleShape
                ),
            contentAlignment = Alignment.Center
        ) {
            // Center retro dot / indicator on knob
            Box(
                modifier = Modifier
                    .size(14.dp)
                    .background(
                        color = if (isDragging) canvasColors.accentColor else canvasColors.hudTextColor,
                        shape = CircleShape
                    )
            )
        }
    }
}


@Composable
private fun ArcadeZoomControls(
    zoomMultiplier: Float,
    onZoomIn: () -> Unit,
    onZoomOut: () -> Unit,
    onResetZoom: () -> Unit,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
) {
    val rounded = round(zoomMultiplier * 10f) / 10f
    val zoomStr = if (rounded % 1f == 0f) "${rounded.toInt()}.0x" else "${rounded}x"

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        modifier = Modifier
            .background(canvasColors.hudBgColor.copy(alpha = 0.85f), RoundedCornerShape(8.dp))
            .border(1.5.dp, canvasColors.hudTextColor.copy(alpha = 0.4f), RoundedCornerShape(8.dp))
            .padding(horizontal = 6.dp, vertical = 4.dp)
    ) {
        val buttonShape = RoundedCornerShape(6.dp)
        val zoomOutInteraction = remember { MutableInteractionSource() }
        // Zoom Out Button [-]
        Box(
            modifier = Modifier
                .size(32.dp)
                .focusProperties { canFocus = false }
                .clip(buttonShape)
                .background(canvasColors.hudBgColor, buttonShape)
                .border(1.5.dp, canvasColors.hudTextColor, buttonShape)
                .clickable(
                    interactionSource = zoomOutInteraction,
                    indication = ripple(bounded = true, color = canvasColors.hudTextColor),
                    role = Role.Button,
                    onClick = onZoomOut,
                ),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(Res.drawable.ic_minus),
                contentDescription = "Zoom Out",
                tint = canvasColors.hudTextColor,
                modifier = Modifier.size(16.dp)
            )
        }

        // Current Zoom Display / Click to reset [1.0x] — fixed width so UI doesn't jump
        val resetShape = RoundedCornerShape(4.dp)
        val resetInteraction = remember { MutableInteractionSource() }
        Box(
            modifier = Modifier
                .width(44.dp)
                .height(32.dp)
                .focusProperties { canFocus = false }
                .clip(resetShape)
                .clickable(
                    interactionSource = resetInteraction,
                    indication = ripple(bounded = true, color = canvasColors.accentColor),
                    onClick = onResetZoom
                ),
            contentAlignment = Alignment.Center
        ) {
            Text(
                text = zoomStr,
                color = if (zoomMultiplier != 1.0f) canvasColors.accentColor else canvasColors.hudTextColor,
                fontSize = 11.sp,
                fontWeight = FontWeight.Bold,
                fontFamily = appFontFamily(),
                maxLines = 1,
            )
        }

        // Zoom In Button [+]
        val zoomInInteraction = remember { MutableInteractionSource() }
        Box(
            modifier = Modifier
                .size(32.dp)
                .focusProperties { canFocus = false }
                .clip(buttonShape)
                .background(canvasColors.hudBgColor, buttonShape)
                .border(1.5.dp, canvasColors.hudTextColor, buttonShape)
                .clickable(
                    interactionSource = zoomInInteraction,
                    indication = ripple(bounded = true, color = canvasColors.hudTextColor),
                    role = Role.Button,
                    onClick = onZoomIn,
                ),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(Res.drawable.ic_plus),
                contentDescription = "Zoom In",
                tint = canvasColors.hudTextColor,
                modifier = Modifier.size(16.dp)
            )
        }
    }
}

@Composable
private fun ArcadeBoostButton(
    isBoosting: Boolean,
    onBoostChange: (Boolean) -> Unit,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isPressed by interactionSource.collectIsPressedAsState()
    val showSpaceHint = supportsKeyboardBoostHint()
    val labelColor = if (isBoosting) Color.Black else canvasColors.accentColor

    LaunchedEffect(isPressed) {
        onBoostChange(isPressed)
    }

    Box(
        modifier = Modifier
            .size(96.dp)
            .focusProperties { canFocus = false }
            .clip(CircleShape)
            .background(
                color = if (isBoosting) canvasColors.accentColor else canvasColors.hudBgColor,
                shape = CircleShape
            )
            .border(
                width = if (isBoosting) 3.dp else 2.dp,
                color = if (isBoosting) Color.White else canvasColors.accentColor,
                shape = CircleShape
            )
            .indication(
                interactionSource = interactionSource,
                indication = ripple(bounded = true, color = canvasColors.accentColor)
            )
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = { offset ->
                        val press = PressInteraction.Press(offset)
                        interactionSource.emit(press)
                        onBoostChange(true)
                        val released = tryAwaitRelease()
                        if (released) {
                            interactionSource.emit(PressInteraction.Release(press))
                        } else {
                            interactionSource.emit(PressInteraction.Cancel(press))
                        }
                        onBoostChange(false)
                    }
                )
            },
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Text(
                text = "⚡",
                fontSize = 26.sp,
                fontFamily = FontFamily.Default
            )
            Text(
                text = stringResource(Res.string.boost),
                color = labelColor,
                fontSize = 12.sp,
                fontWeight = FontWeight.Black,
                fontFamily = appFontFamily()
            )
            if (showSpaceHint) {
                Text(
                    text = "[space]",
                    color = labelColor.copy(alpha = 0.85f),
                    fontSize = 9.sp,
                    fontWeight = FontWeight.Bold,
                    fontFamily = appFontFamily(),
                    letterSpacing = 0.5.sp,
                )
            }
        }
    }
}

@Composable
private fun GameOverOverlay(
    stats: com.snakesworld.game.network.SessionResult?,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
    blockedPlayerIds: Set<String>,
    hiddenLabel: String,
    onPlayAgain: () -> Unit,
    onMainMenu: () -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xCC000000)),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .padding(24.dp)
                .background(canvasColors.hudBgColor, RoundedCornerShape(12.dp))
                .border(2.dp, canvasColors.dangerColor, RoundedCornerShape(12.dp))
                .padding(24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "💥 ${stringResource(Res.string.mission_terminated)}",
                color = canvasColors.dangerColor,
                fontSize = 22.sp,
                fontWeight = FontWeight.Black,
                fontFamily = appFontFamily(),
                letterSpacing = 2.sp
            )

            Spacer(modifier = Modifier.height(8.dp))

            val killerShown = NicknameDisplay.visibleName(
                raw = stats?.killerName.orEmpty(),
                playerId = stats?.killerId.orEmpty(),
                blockedIds = blockedPlayerIds,
                hiddenLabel = hiddenLabel,
            )
            val demiseReason = when (stats?.deathCause) {
                DeathCause.Opponent ->
                    stringResource(Res.string.eliminated_by, killerShown)
                DeathCause.SelfCollision ->
                    stringResource(Res.string.eliminated_self)
                DeathCause.ArenaBoundary, null ->
                    stringResource(Res.string.eliminated_boundary)
            }

            Text(
                text = demiseReason,
                modifier = Modifier.widthIn(max = 300.dp),
                color = canvasColors.hudTextColor.copy(alpha = 0.8f),
                fontSize = 12.sp,
                fontFamily = appFontFamily(),
                maxLines = 1,
                softWrap = false,
                overflow = TextOverflow.Ellipsis,
            )

            Spacer(modifier = Modifier.height(18.dp))

            // Match Stat Readouts
            stats?.let { s ->
                Text(stringResource(Res.string.final_score, s.score), color = canvasColors.accentColor, fontSize = 16.sp, fontWeight = FontWeight.Bold, fontFamily = appFontFamily())
                Text(stringResource(Res.string.final_kills, s.kills), color = canvasColors.hudTextColor, fontSize = 14.sp, fontFamily = appFontFamily())
                val m = s.survivedSeconds / 60
                val sec = s.survivedSeconds % 60
                val timeFormatted = "${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}"
                Text(stringResource(Res.string.time_survived, timeFormatted), color = canvasColors.hudTextColor.copy(alpha = 0.8f), fontSize = 12.sp, fontFamily = appFontFamily())
            }

            Spacer(modifier = Modifier.height(24.dp))

            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Button(
                    onClick = onPlayAgain,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = canvasColors.hudTextColor,
                        contentColor = Color.Black,
                    ),
                    shape = RoundedCornerShape(6.dp),
                    modifier = Modifier.focusProperties { canFocus = false },
                ) {
                    Text(stringResource(Res.string.play_again), color = Color.Black, fontWeight = FontWeight.Black, fontFamily = appFontFamily())
                }

                Button(
                    onClick = onMainMenu,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = canvasColors.hudBgColor,
                        contentColor = canvasColors.hudTextColor,
                    ),
                    shape = RoundedCornerShape(6.dp),
                    modifier = Modifier
                        .border(1.dp, canvasColors.gridColor, RoundedCornerShape(6.dp))
                        .focusProperties { canFocus = false },
                ) {
                    Text(stringResource(Res.string.main_menu), color = canvasColors.hudTextColor, fontFamily = appFontFamily())
                }
            }
        }
    }
}

@Composable
private fun PlayersButton(
    onClick: () -> Unit,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
) {
    val shape = RoundedCornerShape(6.dp)
    val interactionSource = remember { MutableInteractionSource() }
    Box(
        modifier = Modifier
            .focusProperties { canFocus = false }
            .clip(shape)
            .background(canvasColors.hudBgColor, shape)
            .border(1.5.dp, canvasColors.accentColor, shape)
            .clickable(
                interactionSource = interactionSource,
                indication = ripple(bounded = true, color = canvasColors.accentColor),
                role = Role.Button,
                onClick = onClick,
            )
            .padding(horizontal = 10.dp, vertical = 8.dp),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = stringResource(Res.string.players),
            color = canvasColors.accentColor,
            fontSize = 12.sp,
            fontWeight = FontWeight.Black,
            fontFamily = appFontFamily(),
            letterSpacing = 1.sp,
            maxLines = 1,
            softWrap = false,
            overflow = TextOverflow.Ellipsis,
        )
    }
}

@Composable
private fun ArcadePauseButton(
    isPaused: Boolean,
    onTogglePause: () -> Unit,
    modifier: Modifier = Modifier,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors = LocalGameCanvasColors.current,
) {
    val shape = RoundedCornerShape(6.dp)
    val interactionSource = remember { MutableInteractionSource() }

    Box(
        modifier = modifier
            .size(36.dp)
            .focusProperties { canFocus = false }
            .clip(shape)
            .background(canvasColors.hudBgColor, shape)
            .border(1.dp, if (isPaused) canvasColors.accentColor else canvasColors.gridColor, shape)
            .clickable(
                interactionSource = interactionSource,
                indication = ripple(bounded = true, color = if (isPaused) canvasColors.accentColor else canvasColors.hudTextColor),
                role = Role.Button,
                onClick = onTogglePause,
            ),
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            painter = painterResource(if (isPaused) Res.drawable.ic_play else Res.drawable.ic_pause),
            contentDescription = stringResource(if (isPaused) Res.string.resume else Res.string.pause),
            tint = if (isPaused) canvasColors.accentColor else canvasColors.hudTextColor,
            modifier = Modifier.size(18.dp),
        )
    }
}

@Composable
private fun PauseOverlay(
    score: Int,
    kills: Int,
    canvasColors: com.snakesworld.game.ui.theme.GameCanvasColors,
    onResume: () -> Unit,
    onRestart: () -> Unit,
    onMainMenu: () -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xCC000000)),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .padding(24.dp)
                .background(canvasColors.hudBgColor, RoundedCornerShape(12.dp))
                .border(2.dp, canvasColors.accentColor, RoundedCornerShape(12.dp))
                .padding(24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = stringResource(Res.string.game_paused),
                color = canvasColors.accentColor,
                fontSize = 22.sp,
                fontWeight = FontWeight.Black,
                fontFamily = appFontFamily(),
                letterSpacing = 2.sp
            )

            Spacer(modifier = Modifier.height(16.dp))

            // Current Match Stats Readouts
            Text(
                text = "${stringResource(Res.string.score)}: $score",
                color = canvasColors.accentColor,
                fontSize = 16.sp,
                fontWeight = FontWeight.Bold,
                fontFamily = appFontFamily()
            )
            Text(
                text = "${stringResource(Res.string.kills)}: $kills",
                color = canvasColors.hudTextColor,
                fontSize = 14.sp,
                fontFamily = appFontFamily()
            )

            Spacer(modifier = Modifier.height(24.dp))

            Column(
                modifier = Modifier.width(200.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Button(
                    onClick = onResume,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = canvasColors.accentColor,
                        contentColor = Color.Black,
                    ),
                    shape = RoundedCornerShape(6.dp),
                    modifier = Modifier
                        .fillMaxWidth()
                        .focusProperties { canFocus = false },
                ) {
                    Text(
                        text = stringResource(Res.string.resume),
                        color = Color.Black,
                        fontWeight = FontWeight.Black,
                        fontFamily = appFontFamily()
                    )
                }

                Button(
                    onClick = onRestart,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = canvasColors.hudTextColor,
                        contentColor = Color.Black,
                    ),
                    shape = RoundedCornerShape(6.dp),
                    modifier = Modifier
                        .fillMaxWidth()
                        .focusProperties { canFocus = false },
                ) {
                    Text(
                        text = stringResource(Res.string.restart),
                        color = Color.Black,
                        fontWeight = FontWeight.Black,
                        fontFamily = appFontFamily()
                    )
                }

                Button(
                    onClick = onMainMenu,
                    colors = ButtonDefaults.buttonColors(
                        containerColor = canvasColors.hudBgColor,
                        contentColor = canvasColors.hudTextColor,
                    ),
                    shape = RoundedCornerShape(6.dp),
                    modifier = Modifier
                        .fillMaxWidth()
                        .border(1.dp, canvasColors.gridColor, RoundedCornerShape(6.dp))
                        .focusProperties { canFocus = false },
                ) {
                    Text(
                        text = stringResource(Res.string.main_menu),
                        color = canvasColors.hudTextColor,
                        fontFamily = appFontFamily()
                    )
                }
            }
        }
    }
}

private fun handleArcadeKeyEvent(
    keyEvent: KeyEvent,
    viewModel: GameViewModel,
    isSinglePlayer: Boolean,
    isPaused: Boolean,
    isExitDialogVisible: Boolean,
): Boolean {
    if (keyEvent.type == KeyEventType.KeyDown) {
        if (isExitDialogVisible) {
            return if (keyEvent.key == Key.Escape) {
                viewModel.showExitDialog(false)
                true
            } else {
                false
            }
        }
        return when (keyEvent.key) {
            Key.DirectionUp, Key.W, Key.NumPad8 -> {
                viewModel.onDirectionInput(Direction.UP)
                true
            }
            Key.DirectionDown, Key.S, Key.NumPad2 -> {
                viewModel.onDirectionInput(Direction.DOWN)
                true
            }
            Key.DirectionLeft, Key.A, Key.NumPad4 -> {
                viewModel.onDirectionInput(Direction.LEFT)
                true
            }
            Key.DirectionRight, Key.D, Key.NumPad6 -> {
                viewModel.onDirectionInput(Direction.RIGHT)
                true
            }
            Key.Spacebar, Key.ShiftLeft, Key.ShiftRight -> {
                viewModel.onBoostInput(true)
                true
            }
            Key.Plus, Key.Equals, Key.PageUp -> {
                viewModel.onZoomIn()
                true
            }
            Key.Minus, Key.PageDown -> {
                viewModel.onZoomOut()
                true
            }
            Key.Zero, Key.NumPad0 -> {
                viewModel.onResetZoom()
                true
            }
            Key.P -> {
                if (isSinglePlayer) {
                    viewModel.togglePause()
                    true
                } else false
            }
            Key.Escape -> {
                if (isSinglePlayer && isPaused) {
                    viewModel.resumeGame()
                    true
                } else {
                    viewModel.showExitDialog(true)
                    true
                }
            }
            else -> false
        }
    } else if (keyEvent.type == KeyEventType.KeyUp) {
        return when (keyEvent.key) {
            Key.Spacebar, Key.ShiftLeft, Key.ShiftRight -> {
                viewModel.onBoostInput(false)
                true
            }
            else -> false
        }
    }
    return false
}
